import React from 'react';
import { Row, Col, Space, Button, Typography, Image } from 'antd';
import CompanyBrand from '../../Company/CompanyBrand';
import PopupEntry from '../../../components/Inputs/PopupEntry';

const { Title, Text } = Typography;

const DocumentHeader = ({
  logo = false,
  name = '',
  age,
  riskScore,
  title,
  onTitleChange,
  onFinish,
}) => {
  return (
    <div className="bg-white rounded-md shadow-sm">
      {/* TOP TOOLBAR (like Google Docs) */}
      <div className="flex items-center justify-between px-4 py-2 border-b border-gray-200">
        <Row align="middle" style={{ width: '100%' }}>
          {/* Left side - Portfolio Title Input */}
          <Col xs={12} sm={12} md={12} lg={16}>
            <Space align="center" size="middle">
              {/* If you want a tiny brand icon or something in the toolbar, you could place it here */}
              {onTitleChange && (
                <PopupEntry
                  buttonText={title?.trim() || 'Untitled Document'}
                  onSubmit={onTitleChange}
                />
              )}
            </Space>
          </Col>

          {/* Right side - Save Button */}
          <Col xs={12} sm={12} md={12} lg={8} style={{ textAlign: 'right' }}>
            {onFinish && (
              <Button type="primary" onClick={onFinish}>
                Save
              </Button>
            )}
          </Col>
        </Row>
      </div>

      {/* BODY SECTION - Personalized Portfolio Header */}
      <div className="p-6">
        <Row gutter={[16, 16]} align="middle">
          {/* Logo / Branding */}
          {logo && (
            <Col xs={24} sm={8} md={6} lg={4}>
              <div className="mx-auto flex justify-center items-center mb-4 sm:mb-0">
                <CompanyBrand />
              </div>
            </Col>
          )}

          {/* Greeting & Basic Info */}
          <Col xs={24} sm={16} md={logo ? 18 : 24} lg={logo ? 14 : 18}>
            <div className="mb-2">
              <Title level={2} style={{ marginBottom: 0 }}>
                {name?.trim?.() || 'New Model Portfolio'}
              </Title>
              <Text type="secondary" style={{ fontSize: '0.9rem' }}>
                Proposed Personalized Portfolio Model
              </Text>
            </div>
          </Col>

          {/* (Optional) Additional Actions, if needed */}
          {/* e.g., an extra button, your existing "Finish" button, etc.
              But we've already put “Save” in the top toolbar.
          */}
        </Row>

        {/* Additional Client Info - Age, Risk Score, etc. */}
        <div className="mt-4 px-4 sm:px-6">
          <Space size="large">
            {typeof age !== 'undefined' && age !== null && (
              <Text className="text-base">
                <strong>Age:</strong> {age}
              </Text>
            )}

            {typeof riskScore !== 'undefined' && riskScore !== null && (
              <div className="flex items-center">
                <Image
                  src="https://storage.googleapis.com/finiat-web-static-resources/third-party-brands/riskalyze-logo.webp"
                  height={96}
                  preview={false}
                />
                <div className="ml-2">
                  <Text className="text-3xl font-light">{riskScore}</Text>
                </div>
              </div>
            )}
          </Space>
        </div>
      </div>
    </div>
  );
};

export default DocumentHeader;
